export default __webpack_public_path__ + "static/media/template_1.4cc07043.svg";